<template>
  <main class="home">
    <WithdrawalFrozen />
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { setLanguage } from "@/apps/credit-line/helpers/translations.helper";
import WithdrawalFrozen from "@/apps/credit-line/components/WithdrawalFrozen.vue";

export default defineComponent({
  name: "WithdrawalFrozenView",
  components: {
    WithdrawalFrozen,
  },
  beforeMount() {
    setLanguage(this);
  },
  setup() {
    return {};
  },
});
</script>
